import { actions } from './actions'

const initialState = {
  cache: {
    loading: false,
    error: '',
  },
}

export default function cacheReducer(state = initialState, action) {
  switch (action.type) {
    case actions.CACHE_ELIMINAR_CATEGORIA_REQUESTED:
      return {
        ...state,
        cache: { ...state.cache, loading: true, error: '' },
      }
    case actions.CACHE_ELIMINAR_CATEGORIA_SUCCEEDED:
      return {
        ...state,
        cache: {
          ...state.cache,
          loading: false,
          error: '',
        },
      }
    case actions.CACHE_ELIMINAR_CATEGORIA_FILED:
      return {
        ...state,
        cache: { ...state.cache, loading: false, error: action.error },
      }
    case actions.CACHE_ELIMINAR_ETIQUETA_REQUESTED:
      return {
        ...state,
        cache: { ...state.cache, loading: true, error: '' },
      }
    case actions.CACHE_ELIMINAR_ETIQUETA_SUCCEEDED:
      return {
        ...state,
        cache: {
          ...state.cache,
          loading: false,
          error: '',
        },
      }
    case actions.CACHE_ELIMINAR_ETIQUETA_FILED:
      return {
        ...state,
        cache: { ...state.cache, loading: false, error: action.error },
      }
    default:
      return state
  }
}
